import User from "@/interfaces/User.interface";
import api from "@/services/config";

export class UserRest {
    getAllUsers(params: any): Promise<any> {
        return api.get('/user', { params }).then((response) => response.data);
    }

    getUserById(id: any): Promise<any> {
        return api.get(`/user/${id}`).then((response) => response.data);
    }

    getUserInfo(): Promise<any>{
        return api.get('/user/userInfo').then((response) => response.data);
    }

    addUser(data: User): Promise<any> {
        return api.post('/user', data).then((response) => response.data);
    }

    updateUser(id: any, data: User): Promise<any> {
        return api.put(`/user/${id}`, data).then((response) => response.data);
    }

    deleteUser(id: any): Promise<any> {
        return api.delete(`/user/${id}`).then((response) => response.data);
    }

    registerUser(data: User): Promise<any> {
        return api.post('/user/langePage', data).then((response) => response.data);
    }
}